import { useHistory } from "react-router-dom";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, ButtonGroup } from "react-bootstrap";
import { useTranslation } from 'react-i18next';
import { Col, Form, Row } from "react-bootstrap";

export const HeaderRegister = (props) => {
  const history = useHistory();
  const { title, path, submitForm, isDisabled  } = props;

  const showButtonBack = (props.btnBack === undefined ? true : props.btnBack);
  const showCustomButton = (props.customBtnLabel !== undefined)
  const showCustomRightButton = (props.customRightBtnLabel !== undefined)


  const { t } = useTranslation();
  return (
    <>
    <style>
        {`
          .btn-disabled,
          .btn-disabled:disabled {
            background-color: #d6d6d6 !important; /* Cor cinza */
            border-color: #d6d6d6 !important; /* Cor cinza para a borda */
            color: #6c757d !important; /* Cor do texto (cinza escuro) */
            cursor: not-allowed !important; /* Mostra que o botão não pode ser clicado */
          }

          .btn-disabled:hover,
          .btn-disabled:disabled:hover {
            background-color: #d6d6d6 !important; /* Evita mudança de cor ao passar o mouse */
            border-color: #d6d6d6 !important;
          }
        `}
      </style>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2">
        <div className="d-flex mb-4 mb-md-0">
          <h4>{title}</h4>
          {props.mainCheckLabel && (<div style={{float: 'right', marginLeft: '40px'}}>
          <Form>
            <Form.Check
            type="checkbox"
            id="custom-switch"
            label={props.mainCheckLabel}
            onChange={props.mainCheckFunction}
            />
          </Form>
        </div>)}
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
            
            {showButtonBack && (
              <Button
                className="me-2"
                variant="outline-primary"
                onClick={() => history.push(path)}
              >
                <FontAwesomeIcon icon={faArrowLeft} />
                <span> {t('BUTTON_BACK')}</span>
              </Button>
             )}

            {showCustomButton && (
              <Button
              className={`me-2 ${props.isLoading ? 'btn-disabled' : ''}`}
              onClick={props.customBtnFunction}
              disabled={props.isLoading}
            >
              <span>{props.customBtnLabel}</span>
            </Button>
            )}


              <Button 
              className={`me-2 ${props.isLoading || isDisabled ? 'btn-disabled' : ''}`}
              onClick={submitForm} 
              disabled={props.isLoading}>
                <span>{t('BUTTON_SAVE')}</span>
              </Button>

            {showCustomRightButton && (
              <Button
              className={`ml-2 ${props.isLoading || isDisabled ? 'btn-disabled' : ''}`}
              onClick={props.customRightBtnFunction}
              disabled={props.isLoading}
            >
              <span>{props.customRightBtnLabel}</span>
            </Button>
            )}
        </div>
      </div>
    </>
  );
};
